import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom"
import { showToast, ToastMessage } from "../../Shared/ToastMessage"
import axios from "axios"
import { localserver, ROUTE_BASE_URL } from "../../../api/common"
import TimezoneSelect from "react-timezone-select"
import CustomDropdown from "../../common/CustomDropdown"
import { GetStatesData } from "../services/Webservices"
import { uploadFilesAWS } from "../../../api/Webservices"
import {
  FaTimes,
  FaCheck,
  FaArrowLeft,
  FaCalendar,
  FaMapMarkerAlt,
  FaLink,
  FaClock,
  FaImage,
  FaBuilding,
} from "react-icons/fa"

export default function AddUpdateEvent({ isEventSidebarOpen, setEventSidebarOpen }) {
  const history = useHistory()

  const [activeStep, setActiveStep] = useState(1)
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [apiError, setApiError] = useState("")

  const [eventId, setEventId] = useState("")

  // Event basic details
  const [eventName, setEventName] = useState("")
  const [eventType, setEventType] = useState(1)
  const [eventZone, setEventZone] = useState("")
  const eventTypeList = [
    { id: 1, name: "Normal Event" },
    { id: 2, name: "Zonal Event" },
    { id: 3, name: "MMAS Event" },
    { id: 4, name: "FMAS Event" },
    { id: 5, name: "SLCP Event" },
  ];

  const AllzoneData = [
    {
      id: 1,
      value: "South Zone",
      states: ["Andhra Pradesh", "Telangana", "Karnataka", "Tamil Nadu", "Kerala", "Puducherry", "Lakshadweep"],
    },
    {
      id: 2,
      value: "North Zone",
      states: [
        "Jammu and Kashmir",
        "Ladakh",
        "Himachal Pradesh",
        "Punjab",
        "Haryana",
        "Delhi",
        "Uttarakhand",
        "Uttar Pradesh",
        "Chandigarh",
      ],
    },
    {
      id: 3,
      value: "East Zone",
      states: [
        "Bihar",
        "Jharkhand",
        "Odisha",
        "West Bengal",
        "Sikkim",
        "Assam",
        "Arunachal Pradesh",
        "Meghalaya",
        "Manipur",
        "Mizoram",
        "Nagaland",
        "Tripura",
      ],
    },
    {
      id: 4,
      value: "West Zone",
      states: ["Rajasthan", "Gujarat", "Goa", "Maharashtra", "Dadra and Nagar Haveli and Daman and Diu"],
    },
    {
      id: 5,
      value: "Central Zone",
      states: ["Madhya Pradesh", "Chhattisgarh", "Andaman and Nicobar Islands"],
    },
  ]
  const [showEventZone, setShowEventZone] = useState(false)
  const [registrationTitle, setRegistrationTitle] = useState("")
  const [description, setDescription] = useState("")
  const [eventStatus, setEventStatus] = useState("draft")
  const [eventLogo, setEventLogo] = useState(null)

  // Event mode selection
  const [eventMode, setEventMode] = useState("On-Site")
  const eventModeOptions = [{ id: "On-Site", label: "On-Site", icon: <FaBuilding /> }]

  // Event URL customization
  const DEFAULT_EVENT_URL = "https://eventz360.amasi.org/events/registration/"
  const [eventUrl, setEventUrl] = useState(DEFAULT_EVENT_URL + eventName.replace(/\s+/g, "-").toLowerCase())
  const [isEditingUrl, setIsEditingUrl] = useState(false)
  const lastSlashIndex = eventUrl.lastIndexOf("/")
  const eventUrlBase = eventUrl.slice(0, lastSlashIndex + 1)
  const [eventUrlSlug, setEventUrlSlug] = useState(eventUrl.slice(lastSlashIndex + 1))

  // Streaming method
  const [streamingMethod, setStreamingMethod] = useState("RTMP Encoder")

  // Time zone and event time
  const [timeZone, setTimeZone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [startTime, setStartTime] = useState("")
  const [endTime, setEndTime] = useState("")

  // Venue details
  const [venueName, setVenueName] = useState("")
  const [venueCountry, setVenueCountry] = useState(101)
  const [venueCity, setVenueCity] = useState("")
  const [venueState, setVenueState] = useState("")
  const [venueAddress, setVenueAddress] = useState("")
  const [venuePincode, setVenuePincode] = useState("")
  const [mapLink, setMapLink] = useState("")
  const [tags, setTags] = useState("")
  const [venuePhoto, setVenuePhoto] = useState(null)
  const [showDetailedAddress, setShowDetailedAddress] = useState(false)

  // Image upload
  const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/jpg"]
  const MAX_IMAGE_SIZE = 5 * 1024 * 1024 // 5MB
  const [showLogoSection, setShowLogoSection] = useState(false)
  const [showDateTimeSection, setShowDateTimeSection] = useState(false)
  const [showVenueSection, setShowVenueSection] = useState(false)
  const [uploadedLogo, setUploadedLogo] = useState(null)
  const [uploadedVenuePhoto, setUploadedVenuePhoto] = useState(null)
  const [imageError, setImageError] = useState("")
  const [venueImageError, setVenueImageError] = useState("")

  // Country data
  const [countryData, setCountryData] = useState([])
  const [stateList, setStateList] = useState([])

  // Function to sanitize slug
  const sanitizeSlug = (input) => {
    if (!input) return ""
    return input
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
  }

  const resetForm = () => {
    setEventId("")
    setActiveStep(1)
    setErrors({})
    setIsLoading(false)
    setApiError("")
    setEventName("")
    setRegistrationTitle("")
    setDescription("")
    setEventStatus("draft")
    setEventLogo(null)
    setEventMode("On-Site")
    setEventUrl(DEFAULT_EVENT_URL)
    setIsEditingUrl(false)
    setEventUrlSlug(DEFAULT_EVENT_URL.slice(lastSlashIndex + 1))
    setStreamingMethod("RTMP Encoder")
    setTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
    setStartDate("")
    setEndDate("")
    setStartTime("")
    setEndTime("")
    setVenueName("")
    setVenueCountry("")
    setVenueCity("")
    setVenueState("")
    setVenueAddress("")
    setVenuePincode("")
    setMapLink("")
    setTags("")
    setVenuePhoto(null)
    setShowLogoSection(false)
    setShowDateTimeSection(false)
    setShowVenueSection(false)
    setUploadedLogo(null)
    setUploadedVenuePhoto(null)
    setImageError("")
    setVenueImageError("")
    setShowDetailedAddress(false)
  }

  const validateStep = (step) => {
    const newErrors = {}
    let isValid = true

    if (step === 1) {
      if (!eventName.trim()) {
        newErrors.eventName = "Event name is required"
        isValid = false
      }
      if (!description.trim()) {
        newErrors.description = "Description is required"
        isValid = false
      }
      if (!eventType) {
        newErrors.eventType = "Event type is required"
        isValid = false
      }
    } else if (step === 3) {
      if (!eventUrlSlug.trim()) {
        newErrors.eventUrlSlug = "Event URL slug is required"
        isValid = false
      } else if (!/^[a-zA-Z0-9-]+$/i.test(eventUrlSlug.trim())) {
        newErrors.eventUrlSlug = "URL slug must be alphanumeric with hyphens only"
        isValid = false
      }
    } else if (step === 5) {
      if (!timeZone) {
        newErrors.timeZone = "Please select a valid time zone"
        isValid = false
      }
    } else if (step === 6) {
      if (!startDate) {
        newErrors.startDate = "Event start date is required"
        isValid = false
      }
      if (!startTime) {
        newErrors.startTime = "Event start time is required"
        isValid = false
      }
      if (!venueName) {
        newErrors.venueName = "Event venue name is required"
        isValid = false
      }
      if (!venueCountry) {
        newErrors.venueCountry = "Event venue country is required"
        isValid = false
      }
      if (!venueState) {
        newErrors.venueState = "Event venue state is required"
        isValid = false
      }
    }

    setErrors(newErrors)
    return isValid
  }

  const handleProceed = () => {
    if (validateStep(activeStep)) {
      setErrors({})
      if (activeStep === 5) {
        handleSaveEvent()
      } else {
        nextStep()
      }
    }
  }

  const nextStep = () => {
    if (activeStep < 6) {
      if (activeStep === 3 && eventMode === "On-Site") {
        setActiveStep(activeStep + 2)
        return
      }
      setActiveStep(activeStep + 1)
    }
  }

  const prevStep = () => {
    if (activeStep > 1) {
      setErrors({})
      if (activeStep === 5 && eventMode === "On-Site") {
        setActiveStep(activeStep - 2)
        return
      }
      setActiveStep(activeStep - 1)
    }
  }

  const handleSaveUrl = () => {
    if (validateStep(3)) {
      setEventUrl(eventUrlBase + eventUrlSlug)
      setIsEditingUrl(false)
      setErrors({})
    }
  }

  const MIN_DIMENSION = 90
  const MAX_DIMENSION = 160

  const validateImage = (file, type) => {
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      return `${type === "logo" ? "Event logo" : "Venue photo"} must be JPG, JPEG, or PNG format.`
    }

    if (file.size > MAX_IMAGE_SIZE) {
      return `${type === "logo" ? "Event logo" : "Venue photo"} size must not exceed 5MB.`
    }

    return new Promise((resolve) => {
      const img = new Image()
      const objectUrl = URL.createObjectURL(file)

      img.onload = () => {
        console.log(`Image dimensions: ${img.width} × ${img.height}`)
        const isWidthValid = img.width >= MIN_DIMENSION && img.width <= MAX_DIMENSION
        const isHeightValid = img.height >= MIN_DIMENSION && img.height <= MAX_DIMENSION
        if (
          !(isWidthValid && isHeightValid) ||
          (img.width !== 150 && img.height !== 100 && img.width !== 100 && img.height !== 150)
        ) {
          URL.revokeObjectURL(objectUrl)
          resolve(
            `${type === "logo" ? "Event logo" : "Venue photo"} dimensions must be approximately 150 × 100 or 100 × 150 pixels (within 90-160 × 90-160).`,
          )
        } else {
          URL.revokeObjectURL(objectUrl)
          resolve(null)
        }
      }

      img.onerror = () => {
        URL.revokeObjectURL(objectUrl)
        resolve(`Failed to load ${type === "logo" ? "event logo" : "venue photo"}. Please try again.`)
      }

      img.src = objectUrl
    })
  }

  const handleFileChange = (type) => async (event) => {
    const file = event.target.files[0]
    if (!file) return

    const validationError = await validateImage(file, type)
    if (validationError) {
      if (type === "logo") {
        setImageError(validationError)
      } else {
        setVenueImageError(validationError)
      }
      return
    }

    try {
      const res = await uploadFilesAWS({ upload_files: file })
      if (res.data && res.data.success === true) {
        const uploadedUrl = res.data.uploadedUrls.upload_files[0]
        if (type === "logo") {
          setEventLogo(uploadedUrl)
          setUploadedLogo(URL.createObjectURL(file))
          setImageError("")
        } else {
          setVenuePhoto(uploadedUrl)
          setUploadedVenuePhoto(URL.createObjectURL(file))
          setVenueImageError("")
        }
        showToast("Image uploaded successfully", "success")
      } else {
        showToast(res.message || "Failed to upload image", "error")
      }
    } catch (error) {
      console.error(`Error uploading ${type} image:`, error)
      showToast(`Failed to upload ${type === "logo" ? "event logo" : "venue photo"}. Please try again.`, "error")
    }
  }

  const removeImage = (type) => () => {
    if (type === "logo") {
      setUploadedLogo(null)
      setEventLogo(null)
    } else {
      setUploadedVenuePhoto(null)
      setVenuePhoto(null)
    }
  }

  const formatDateTime = (date, time) => {
    if (!date || !time) return null
    return `${new Date(date).toISOString().slice(0, 10)} ${new Date(`1970-01-01T${time}`).toTimeString().slice(0, 8)}`
  }

  const handleSaveEvent = async () => {
    if (validateStep(activeStep)) {
      setIsLoading(true)
      setApiError("")
      const eventApiUrl = eventId ? "update_event_details" : "create_event"
      const eventData = {
        ...(eventId && { event_id: eventId }),
        event_basic_details: {
          event_name: eventName,
          registration_title: registrationTitle,
          registration_url: eventUrl,
          description,
          event_logo: eventLogo || "",
          event_status: eventStatus,
          event_policy: null,
          is_zonal: eventType - 1,
          zone: eventZone || null,
        },
        venue_details: {
          time_zone: timeZone,
          venue: venueName || "",
          tags: tags || "",
          venue_name: venueName || "",
          venue_photo: venuePhoto || "",
          venue_city: venueCity || "",
          venue_state: venueState || "",
          venue_address: venueAddress || "",
          venue_pincode: venuePincode || "",
          map_link: mapLink || "",
          state_id: venueState,
          country_id: venueCountry,
        },
        event_types: {
          event_type: eventMode,
          streaming_method: streamingMethod,
        },
        event_time: {
          start_date: startDate ? new Date(startDate).toISOString().slice(0, 10) : null,
          end_date: endDate ? new Date(endDate).toISOString().slice(0, 10) : null,
          start_time: startTime || null,
          end_time: endTime || null,
          event_date: startDate && startTime ? `${new Date(startDate).toISOString().slice(0, 10)} ${startTime}` : null,
        },
      }
      console.log("Event Data:", eventData)
      try {
        const response = await axios.post(`${localserver}/${eventApiUrl}`, eventData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        if (response.data.success) {
          if (activeStep === 5) {
            setEventId(response.data.result.id)
          }
          showToast(response.data.message, "success")
          if (activeStep === 6) {
            setTimeout(() => {
              resetForm()
              setEventSidebarOpen(false)
              history.push(`${ROUTE_BASE_URL}/event-overview/${eventId || response.data.result.id}`)
              window.location.reload()
            }, 1500)
          } else {
            nextStep()
          }
        } else {
          if (response.data.success === true) {
            showToast(response.data.message, "success")
          } else {
            showToast(response.data.message, "error")
          }
          throw new Error(response.data.message || "Failed to save event")
        }
      } catch (error) {
        setApiError(error.message || "An error occurred while saving the event.")
      } finally {
        setIsLoading(false)
      }
    } else {
      showToast("Please fill in the required details.", "error")
    }
  }

  const handleDoitLater = () => {
    // resetForm()
    // setEventSidebarOpen(false)
    // history.push(`${ROUTE_BASE_URL}/event-overview/${eventId}`)
    setTimeout(() => {
      resetForm()
      setEventSidebarOpen(false)
      history.push(`${ROUTE_BASE_URL}/event-overview/${eventId}`)
      window.location.reload()
    }, 1500)
  }

  const getCountries = async () => {
    try {
      const response = await axios.get(`${localserver}/get_countries`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
      if (response.data.success) {
        setCountryData(response.data.countries)
      } else {
        console.error("Error: Failed to fetch user data")
      }
    } catch (error) {
      console.error("Error fetching countries data:", error)
    }
  }

  const handleCountrydata = async (value) => {
    const countryId = String(value)
    console.log("handleCountrydata called with country:", countryId)
    setVenueCountry(countryId)
    if (countryId) {
      try {
        const response = await GetStatesData(countryId)
        console.log("States response for country", countryId, ":", response)
        setStateList(response)
      } catch (error) {
        console.error("Error fetching states:", error)
        setStateList([])
      }
    } else {
      setStateList([])
    }
  }

  const handleStatedata = async (value) => {
    const stateId = Number(value)
    console.log("handleCountrydata called with country:", stateId)
    setVenueState(stateId)
    const selectedState = stateList.find((state) => state.id === stateId)
    console.log(selectedState, "Selected State")
    if (selectedState) {
      try {
        const foundZone = AllzoneData.find((zone) => {
          return Array.isArray(zone.states) && zone.states.includes(selectedState.name)
        })
        console.log(foundZone, "Found Zone")
        if (foundZone) {
          setEventZone(foundZone.value)
        } else {
          setEventZone("")
        }
      } catch (error) {
        console.error("Error fetching states:", error)
      }
    }
  }

  const handleEventType = async (value) => {
    setEventType(value)
  }

  const handleZone = async (value) => {
    setEventZone(value)
  }

  useEffect(() => {
    getCountries()
  }, [])

  useEffect(() => {
    if (venueCountry && !stateList.length) {
      console.log("Fetching states for country:", venueCountry)
      handleCountrydata(venueCountry)
    }
  }, [venueCountry])

  useEffect(() => {
    const sanitizedSlug = sanitizeSlug(eventName)
    const newEventUrl = DEFAULT_EVENT_URL + sanitizedSlug
    setEventUrl(newEventUrl)
    setEventUrlSlug(sanitizedSlug)
  }, [eventName])

  return (
    <div>
      <ToastMessage />
      <div
        className={`extraspace_search_div1 search_div${isEventSidebarOpen ? " open" : ""}`}
        style={{
          position: "fixed",
          right: isEventSidebarOpen ? "0" : "-100%",
          top: "0",
          height: "100vh",
          width: "600px",
          maxWidth: "90vw",
          backgroundColor: "#ffffff",
          boxShadow: isEventSidebarOpen ? "-4px 0 16px rgba(0, 0, 0, 0.1)" : "none",
          transition: "right 0.3s ease-in-out",
          zIndex: 1000,
          overflowY: "auto",
        }}
      >
        <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
          {/* Header */}
          <div
            style={{
              background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
              padding: "24px",
              color: "#ffffff",
              position: "sticky",
              top: 0,
              zIndex: 10,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                {activeStep > 1 && (
                  <button
                    onClick={prevStep}
                    style={{
                      background: "rgba(255, 255, 255, 0.2)",
                      border: "none",
                      borderRadius: "8px",
                      color: "#ffffff",
                      width: "36px",
                      height: "36px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      fontSize: "16px",
                      transition: "all 0.2s ease",
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.background = "rgba(255, 255, 255, 0.3)")}
                    onMouseOut={(e) => (e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)")}
                  >
                    <FaArrowLeft />
                  </button>
                )}
                <div>
                  <h3 style={{ margin: 0, fontSize: "20px", fontWeight: "600" }}>
                    {activeStep === 1 && "Event Details"}
                    {activeStep === 2 && "Event Mode"}
                    {activeStep === 3 && "Customize Link"}
                    {activeStep === 4 && "Streaming Method"}
                    {activeStep === 5 && "Time Zone"}
                    {activeStep === 6 && "Additional Details"}
                  </h3>
                  <p style={{ margin: "4px 0 0 0", fontSize: "14px", opacity: 0.9 }}>Step {activeStep} of 6</p>
                </div>
              </div>
              <button
                onClick={() => {
                  resetForm()
                  setEventSidebarOpen(false)
                }}
                style={{
                  background: "rgba(255, 255, 255, 0.2)",
                  border: "none",
                  borderRadius: "8px",
                  color: "#ffffff",
                  width: "36px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  transition: "all 0.2s ease",
                }}
                onMouseOver={(e) => (e.currentTarget.style.background = "rgba(255, 255, 255, 0.3)")}
                onMouseOut={(e) => (e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)")}
              >
                <FaTimes />
              </button>
            </div>

            {/* Progress Bar */}
            <div
              style={{
                marginTop: "20px",
                height: "4px",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                borderRadius: "2px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: `${(activeStep / 6) * 100}%`,
                  backgroundColor: "#ffffff",
                  transition: "width 0.3s ease",
                }}
              />
            </div>
          </div>

          {/* Content */}
          <div style={{ flex: 1, padding: "32px 24px" }}>
            {activeStep === 1 && (
              <div>
                <div style={{ textAlign: "center", marginBottom: "32px" }}>
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "16px",
                      background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                    }}
                  >
                    <FaCalendar size={32} color="#184778" />
                  </div>
                  <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#1a1a1a", margin: "0 0 8px 0" }}>
                    Event Details
                  </h4>
                  <p style={{ fontSize: "14px", color: "#666666", margin: 0 }}>
                    Provide your event details. You can always change this later.
                  </p>
                </div>

                <div style={{ marginBottom: "24px" }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#374151",
                      marginBottom: "8px",
                    }}
                  >
                    Event Name <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={eventName}
                    onChange={(e) => setEventName(e.target.value)}
                    style={{
                      padding: "12px 16px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "8px",
                      fontSize: "14px",
                      transition: "border-color 0.2s ease",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#184778")}
                    onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                    required
                  />
                  {errors.eventName && (
                    <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{errors.eventName}</p>
                  )}
                </div>

                <div style={{ marginBottom: "24px" }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#374151",
                      marginBottom: "8px",
                    }}
                  >
                    Description <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <textarea
                    className="form-control"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    rows={4}
                    style={{
                      padding: "12px 16px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "8px",
                      fontSize: "14px",
                      transition: "border-color 0.2s ease",
                      resize: "vertical",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#184778")}
                    onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                    required
                  />
                  {errors.description && (
                    <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{errors.description}</p>
                  )}
                </div>

                <div style={{ marginBottom: "24px" }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#374151",
                      marginBottom: "8px",
                    }}
                  >
                    Event Category <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <CustomDropdown
                    dropdownData={eventTypeList}
                    dropdownValue={eventType}
                    setDropdownValue={handleEventType}
                    ShouldValidate={true}
                    name="Event Type"
                    fieldName="event_type"
                    errors={errors}
                    eventType={"Update"}
                  />
                </div>
              </div>
            )}

            {activeStep === 2 && (
              <div>
                <div style={{ textAlign: "center", marginBottom: "32px" }}>
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "16px",
                      background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                    }}
                  >
                    <FaMapMarkerAlt size={32} color="#d97706" />
                  </div>
                  <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#1a1a1a", margin: "0 0 8px 0" }}>
                    Event Mode
                  </h4>
                  <p style={{ fontSize: "14px", color: "#666666", margin: 0 }}>
                    Select the type of event you want to host.
                  </p>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  {eventModeOptions.map((option) => (
                    <div
                      key={option.id}
                      onClick={() => setEventMode(option.id)}
                      style={{
                        padding: "20px",
                        border: eventMode === option.id ? "2px solid #184778" : "2px solid #e5e7eb",
                        borderRadius: "12px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        backgroundColor: eventMode === option.id ? "#f0f9ff" : "#ffffff",
                        transition: "all 0.2s ease",
                        position: "relative",
                      }}
                      onMouseOver={(e) => {
                        if (eventMode !== option.id) {
                          e.currentTarget.style.borderColor = "#9ca3af"
                        }
                      }}
                      onMouseOut={(e) => {
                        if (eventMode !== option.id) {
                          e.currentTarget.style.borderColor = "#e5e7eb"
                        }
                      }}
                    >
                      <div
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "12px",
                          background:
                            eventMode === option.id ? "linear-gradient(135deg, #184778 0%, #2563a8 100%)" : "#f3f4f6",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "20px",
                          color: eventMode === option.id ? "#ffffff" : "#6b7280",
                        }}
                      >
                        {option.icon}
                      </div>
                      <span style={{ fontSize: "16px", fontWeight: "500", color: "#1a1a1a" }}>{option.label}</span>
                      {eventMode === option.id && (
                        <div
                          style={{
                            position: "absolute",
                            right: "20px",
                            width: "24px",
                            height: "24px",
                            borderRadius: "50%",
                            backgroundColor: "#184778",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#ffffff",
                          }}
                        >
                          <FaCheck size={12} />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeStep === 3 && (
              <div>
                <div style={{ textAlign: "center", marginBottom: "32px" }}>
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "16px",
                      background: "linear-gradient(135deg, #fae8ff 0%, #f3e8ff 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                    }}
                  >
                    <FaLink size={32} color="#9333ea" />
                  </div>
                  <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#1a1a1a", margin: "0 0 8px 0" }}>
                    Customize Event Link
                  </h4>
                  <p style={{ fontSize: "14px", color: "#666666", margin: 0 }}>
                    Customize the event link. You can always change this later.
                  </p>
                </div>

                <div
                  style={{
                    padding: "16px",
                    backgroundColor: "#f9fafb",
                    borderRadius: "12px",
                    border: "1px solid #e5e7eb",
                    marginBottom: "20px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
                    <FaLink style={{ color: "#6b7280" }} />
                    <input
                      type="text"
                      value={eventUrl}
                      readOnly
                      style={{
                        flex: 1,
                        padding: "8px 12px",
                        border: "1px solid #d1d5db",
                        borderRadius: "6px",
                        fontSize: "14px",
                        backgroundColor: "#ffffff",
                      }}
                    />
                  </div>
                  {!isEditingUrl && (
                    <button
                      onClick={() => setIsEditingUrl(true)}
                      style={{
                        width: "100%",
                        padding: "10px",
                        background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                        border: "none",
                        borderRadius: "8px",
                        color: "#ffffff",
                        fontSize: "14px",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      Edit URL
                    </button>
                  )}
                </div>

                {isEditingUrl && (
                  <div
                    style={{
                      padding: "20px",
                      backgroundColor: "#ffffff",
                      borderRadius: "12px",
                      border: "2px solid #184778",
                    }}
                  >
                    <label
                      style={{
                        display: "block",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#374151",
                        marginBottom: "8px",
                      }}
                    >
                      Custom URL Slug
                    </label>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                      <span style={{ fontSize: "14px", color: "#6b7280" }}>{eventUrlBase}</span>
                      <input
                        type="text"
                        value={eventUrlSlug}
                        onChange={(e) => setEventUrlSlug(e.target.value)}
                        style={{
                          flex: 1,
                          padding: "10px 12px",
                          border: "2px solid #e5e7eb",
                          borderRadius: "6px",
                          fontSize: "14px",
                          width:"100%"
                        }}
                      />
                    </div>
                    {errors.eventUrlSlug && (
                      <p style={{ color: "#ef4444", fontSize: "12px", marginBottom: "12px" }}>{errors.eventUrlSlug}</p>
                    )}
                    <div style={{ display: "flex", gap: "12px" }}>
                      <button
                        onClick={() => setIsEditingUrl(false)}
                        style={{
                          flex: 1,
                          padding: "10px",
                          border: "2px solid #e5e7eb",
                          borderRadius: "8px",
                          backgroundColor: "#ffffff",
                          color: "#374151",
                          fontSize: "14px",
                          fontWeight: "500",
                          cursor: "pointer",
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleSaveUrl}
                        style={{
                          flex: 1,
                          padding: "10px",
                          background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                          border: "none",
                          borderRadius: "8px",
                          color: "#ffffff",
                          fontSize: "14px",
                          fontWeight: "500",
                          cursor: "pointer",
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {activeStep === 4 && (
              <div>
                <div style={{ textAlign: "center", marginBottom: "32px" }}>
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "16px",
                      background: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                    }}
                  >
                    <FaImage size={32} color="#2563eb" />
                  </div>
                  <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#1a1a1a", margin: "0 0 8px 0" }}>
                    Streaming Method
                  </h4>
                  <p style={{ fontSize: "14px", color: "#666666", margin: 0 }}>Choose a streaming method you prefer.</p>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  <div
                    onClick={() => setStreamingMethod("RTMP Encoder")}
                    style={{
                      padding: "20px",
                      border: streamingMethod === "RTMP Encoder" ? "2px solid #184778" : "2px solid #e5e7eb",
                      borderRadius: "12px",
                      cursor: "pointer",
                      backgroundColor: streamingMethod === "RTMP Encoder" ? "#f0f9ff" : "#ffffff",
                      transition: "all 0.2s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                    }}
                  >
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        border: `2px solid ${streamingMethod === "RTMP Encoder" ? "#184778" : "#d1d5db"}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {streamingMethod === "RTMP Encoder" && (
                        <div
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            backgroundColor: "#184778",
                          }}
                        />
                      )}
                    </div>
                    <span style={{ fontSize: "16px", fontWeight: "500", color: "#1a1a1a" }}>RTMP Encoder</span>
                  </div>

                  <div
                    onClick={() => setStreamingMethod("Zoom")}
                    style={{
                      padding: "20px",
                      border: streamingMethod === "Zoom" ? "2px solid #184778" : "2px solid #e5e7eb",
                      borderRadius: "12px",
                      cursor: "not-allowed",
                      backgroundColor: "#f9fafb",
                      opacity: 0.6,
                      transition: "all 0.2s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          border: "2px solid #d1d5db",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      />
                      <span style={{ fontSize: "16px", fontWeight: "500", color: "#6b7280" }}>Zoom</span>
                    </div>
                    <span
                      style={{
                        fontSize: "12px",
                        padding: "4px 8px",
                        backgroundColor: "#f3f4f6",
                        borderRadius: "4px",
                        color: "#6b7280",
                      }}
                    >
                      Coming Soon
                    </span>
                  </div>
                </div>
              </div>
            )}

            {activeStep === 5 && (
              <div>
                <div style={{ textAlign: "center", marginBottom: "32px" }}>
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "16px",
                      background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                    }}
                  >
                    <FaClock size={32} color="#d97706" />
                  </div>
                  <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#1a1a1a", margin: "0 0 8px 0" }}>
                    Time Zone
                  </h4>
                  <p style={{ fontSize: "14px", color: "#666666", margin: 0 }}>
                    Specify the time zone for your event's date and time.
                  </p>
                </div>

                <div style={{ marginBottom: "24px" }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#374151",
                      marginBottom: "8px",
                    }}
                  >
                    Select Time Zone <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <TimezoneSelect value={timeZone} onChange={(tz) => setTimeZone(tz.value)} />
                  {errors.timeZone && (
                    <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{errors.timeZone}</p>
                  )}
                </div>
              </div>
            )}

            {activeStep === 6 && (
              <div>
                <div style={{ textAlign: "center", marginBottom: "32px" }}>
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "16px",
                      background: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                    }}
                  >
                    <FaCheck size={32} color="#059669" />
                  </div>
                  <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#1a1a1a", margin: "0 0 8px 0" }}>
                    Awesome! Your event has been created!
                  </h4>
                  <p style={{ fontSize: "14px", color: "#666666", margin: 0 }}>
                    Would you like to add these additional details now?
                  </p>
                </div>

                {/* Add Logo Section */}
                <div
                  style={{
                    padding: "16px",
                    border: "2px solid #e5e7eb",
                    borderRadius: "12px",
                    marginBottom: "16px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: showLogoSection ? "16px" : 0,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <FaImage style={{ color: "#6b7280" }} />
                      <span style={{ fontSize: "14px", fontWeight: "500", color: "#1a1a1a" }}>
                        Add an Event / Organizer Logo
                      </span>
                    </div>
                    <button
                      onClick={() => setShowLogoSection(!showLogoSection)}
                      style={{
                        padding: "6px 16px",
                        border: showLogoSection ? "1px solid #ef4444" : "1px solid #184778",
                        borderRadius: "6px",
                        backgroundColor: "#ffffff",
                        color: showLogoSection ? "#ef4444" : "#184778",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    >
                      {showLogoSection ? "Remove" : "Add"}
                    </button>
                  </div>

                  {showLogoSection && (
                    <div style={{ paddingTop: "12px", borderTop: "1px solid #e5e7eb" }}>
                      {!uploadedLogo ? (
                        <div style={{ textAlign: "center" }}>
                          <input
                            type="file"
                            id="file-upload-logo"
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={handleFileChange("logo")}
                            hidden
                          />
                          <img
                            src="https://member2025.s3.ap-south-1.amazonaws.com/events/dummylogo.png"
                            alt="Placeholder"
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              marginBottom: "12px",
                            }}
                          />
                          <button
                            onClick={() => document.getElementById("file-upload-logo").click()}
                            style={{
                              padding: "8px 16px",
                              border: "2px dashed #d1d5db",
                              borderRadius: "8px",
                              backgroundColor: "#f9fafb",
                              color: "#374151",
                              fontSize: "14px",
                              cursor: "pointer",
                              display: "block",
                              width: "100%",
                            }}
                          >
                            Upload Logo
                          </button>
                          <p style={{ fontSize: "12px", color: "#6b7280", marginTop: "8px" }}>
                            Accepted: JPG, JPEG, PNG (150 × 100 pixels)
                          </p>
                        </div>
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <img
                            src={uploadedLogo || "/placeholder.svg"}
                            alt="Uploaded"
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              marginBottom: "12px",
                            }}
                          />
                          <button
                            onClick={removeImage("logo")}
                            style={{
                              padding: "8px 16px",
                              border: "none",
                              borderRadius: "8px",
                              backgroundColor: "#ef4444",
                              color: "#ffffff",
                              fontSize: "14px",
                              cursor: "pointer",
                              display: "block",
                              width: "100%",
                            }}
                          >
                            <FaTimes style={{ marginRight: "6px" }} />
                            Remove
                          </button>
                        </div>
                      )}
                      {imageError && (
                        <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "8px" }}>{imageError}</p>
                      )}
                    </div>
                  )}
                </div>

                {/* Add Date & Time Section */}
                <div
                  style={{
                    padding: "16px",
                    border: "2px solid #e5e7eb",
                    borderRadius: "12px",
                    marginBottom: "16px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: showDateTimeSection ? "16px" : 0,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <FaCalendar style={{ color: "#6b7280" }} />
                      <span style={{ fontSize: "14px", fontWeight: "500", color: "#1a1a1a" }}>Add Date & Time</span>
                    </div>
                    <button
                      onClick={() => setShowDateTimeSection(!showDateTimeSection)}
                      style={{
                        padding: "6px 16px",
                        border: showDateTimeSection ? "1px solid #ef4444" : "1px solid #184778",
                        borderRadius: "6px",
                        backgroundColor: "#ffffff",
                        color: showDateTimeSection ? "#ef4444" : "#184778",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    >
                      {showDateTimeSection ? "Remove" : "Add"}
                    </button>
                  </div>

                  {showDateTimeSection && (
                    <div style={{ paddingTop: "12px", borderTop: "1px solid #e5e7eb" }}>
                      <div style={{ marginBottom: "16px" }}>
                        <TimezoneSelect value={timeZone} onChange={(tz) => setTimeZone(tz.value)} />
                      </div>
                      <div className="row">
                        <div className="col-md-6" style={{ marginBottom: "16px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                            }}
                          >
                            Start Date <span style={{ color: "#ef4444" }}>*</span>
                          </label>
                          <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              border: "2px solid #e5e7eb",
                              borderRadius: "8px",
                              fontSize: "14px",
                            }}
                          />
                          {errors.startDate && (
                            <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{errors.startDate}</p>
                          )}
                        </div>
                        <div className="col-md-6" style={{ marginBottom: "16px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                            }}
                          >
                            End Date
                          </label>
                          <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              border: "2px solid #e5e7eb",
                              borderRadius: "8px",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                        <div className="col-md-6" style={{ marginBottom: "16px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                            }}
                          >
                            Start Time <span style={{ color: "#ef4444" }}>*</span>
                          </label>
                          <input
                            type="time"
                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              border: "2px solid #e5e7eb",
                              borderRadius: "8px",
                              fontSize: "14px",
                            }}
                          />
                          {errors.startTime && (
                            <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{errors.startTime}</p>
                          )}
                        </div>
                        <div className="col-md-6" style={{ marginBottom: "16px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                            }}
                          >
                            End Time
                          </label>
                          <input
                            type="time"
                            value={endTime}
                            onChange={(e) => setEndTime(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              border: "2px solid #e5e7eb",
                              borderRadius: "8px",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Add Venue Section */}
                <div
                  style={{
                    padding: "16px",
                    border: "2px solid #e5e7eb",
                    borderRadius: "12px",
                    marginBottom: "16px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: showVenueSection ? "16px" : 0,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <FaMapMarkerAlt style={{ color: "#6b7280" }} />
                      <span style={{ fontSize: "14px", fontWeight: "500", color: "#1a1a1a" }}>Add Venue</span>
                    </div>
                    <button
                      onClick={() => setShowVenueSection(!showVenueSection)}
                      style={{
                        padding: "6px 16px",
                        border: showVenueSection ? "1px solid #ef4444" : "1px solid #184778",
                        borderRadius: "6px",
                        backgroundColor: "#ffffff",
                        color: showVenueSection ? "#ef4444" : "#184778",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    >
                      {showVenueSection ? "Remove" : "Add"}
                    </button>
                  </div>

                  {showVenueSection && (
                    <div style={{ paddingTop: "12px", borderTop: "1px solid #e5e7eb" }}>
                      {!uploadedVenuePhoto ? (
                        <div style={{ textAlign: "center", marginBottom: "16px" }}>
                          <input
                            type="file"
                            id="file-upload-venue"
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={handleFileChange("venue")}
                            hidden
                          />
                          <img
                            src="https://member2025.s3.ap-south-1.amazonaws.com/events/dummylogo.png"
                            alt="Placeholder"
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              marginBottom: "12px",
                            }}
                          />
                          <button
                            onClick={() => document.getElementById("file-upload-venue").click()}
                            style={{
                              padding: "8px 16px",
                              border: "2px dashed #d1d5db",
                              borderRadius: "8px",
                              backgroundColor: "#f9fafb",
                              color: "#374151",
                              fontSize: "14px",
                              cursor: "pointer",
                              display: "block",
                              width: "100%",
                            }}
                          >
                            Upload Venue Photo
                          </button>
                          <p style={{ fontSize: "12px", color: "#6b7280", marginTop: "8px" }}>
                            Photo Should be JPG, JPEG, PNG (150 × 100 pixels)
                          </p>
                          {venueImageError && <p style={{ color: "#ef4444", fontSize: "12px" }}>{venueImageError}</p>}
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", marginBottom: "16px" }}>
                          <img
                            src={uploadedVenuePhoto || "/placeholder.svg"}
                            alt="Uploaded"
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              marginBottom: "12px",
                            }}
                          />
                          <button
                            onClick={removeImage("venue")}
                            style={{
                              padding: "8px 16px",
                              border: "none",
                              borderRadius: "8px",
                              backgroundColor: "#ef4444",
                              color: "#ffffff",
                              fontSize: "14px",
                              cursor: "pointer",
                              display: "block",
                              width: "100%",
                            }}
                          >
                            <FaTimes style={{ marginRight: "6px" }} />
                            Remove
                          </button>
                        </div>
                      )}

                      <div className="row">
                        <div className="col-md-12" style={{ marginBottom: "16px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                            }}
                          >
                            Venue Name <span style={{ color: "#ef4444" }}>*</span>
                          </label>
                          <input
                            type="text"
                            value={venueName}
                            onChange={(e) => setVenueName(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              border: "2px solid #e5e7eb",
                              borderRadius: "8px",
                              fontSize: "14px",
                            }}
                          />
                          {errors.venueName && (
                            <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{errors.venueName}</p>
                          )}
                        </div>

                        <div className="col-md-6" style={{ marginBottom: "16px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                            }}
                          >
                            City
                          </label>
                          <input
                            type="text"
                            value={venueCity}
                            onChange={(e) => setVenueCity(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              border: "2px solid #e5e7eb",
                              borderRadius: "8px",
                              fontSize: "14px",
                            }}
                          />
                        </div>

                        <div className="col-md-6" style={{ marginBottom: "16px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                            }}
                          >
                            Country <span style={{ color: "#ef4444" }}>*</span>
                          </label>
                          <CustomDropdown
                            dropdownData={countryData}
                            dropdownValue={venueCountry}
                            setDropdownValue={handleCountrydata}
                            ShouldValidate={true}
                            name="country name"
                            fieldName="country"
                            errors={errors}
                            eventType={"Update"}
                          />
                          {errors.venueCountry && (
                            <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>
                              {errors.venueCountry}
                            </p>
                          )}
                        </div>

                        <div className="col-md-12" style={{ marginBottom: "16px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                            }}
                          >
                            Street Address
                          </label>
                          <input
                            type="text"
                            value={venueAddress}
                            onChange={(e) => setVenueAddress(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              border: "2px solid #e5e7eb",
                              borderRadius: "8px",
                              fontSize: "14px",
                            }}
                          />
                        </div>

                        <div className="col-md-6" style={{ marginBottom: "16px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                            }}
                          >
                            State <span style={{ color: "#ef4444" }}>*</span>
                          </label>
                          <CustomDropdown
                            dropdownData={stateList}
                            dropdownValue={venueState}
                            setDropdownValue={handleStatedata}
                            name="state name"
                            fieldName="state"
                            eventType={"Add"}
                          />
                          {errors.venueState && (
                            <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{errors.venueState}</p>
                          )}
                        </div>

                        <div className="col-md-6" style={{ marginBottom: "16px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                            }}
                          >
                            ZIP / Postal Code
                          </label>
                          <input
                            type="text"
                            value={venuePincode}
                            onChange={(e) => setVenuePincode(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              border: "2px solid #e5e7eb",
                              borderRadius: "8px",
                              fontSize: "14px",
                            }}
                          />
                        </div>

                        <div className="col-md-12" style={{ marginBottom: "16px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                            }}
                          >
                            Google Map URL
                          </label>
                          <input
                            type="text"
                            value={mapLink}
                            onChange={(e) => setMapLink(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              border: "2px solid #e5e7eb",
                              borderRadius: "8px",
                              fontSize: "14px",
                            }}
                          />
                        </div>

                        <div className="col-md-12">
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                            }}
                          >
                            Tags (comma-separated)
                          </label>
                          <input
                            type="text"
                            value={tags}
                            onChange={(e) => setTags(e.target.value)}
                            placeholder="e.g., Tech, Developers"
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              border: "2px solid #e5e7eb",
                              borderRadius: "8px",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Footer */}
          <div
            style={{
              padding: "24px",
              borderTop: "1px solid #e5e7eb",
              backgroundColor: "#f9fafb",
              position: "sticky",
              bottom: 0,
            }}
          >
            {activeStep === 6 ? (
              <div style={{ display: "flex", gap: "12px" }}>
                <button
                  onClick={handleDoitLater}
                  disabled={isLoading}
                  style={{
                    flex: 1,
                    padding: "12px",
                    border: "2px solid #e5e7eb",
                    borderRadius: "8px",
                    backgroundColor: "#ffffff",
                    color: "#374151",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: isLoading ? "not-allowed" : "pointer",
                    opacity: isLoading ? 0.6 : 1,
                  }}
                >
                  Do it Later
                </button>
                <button
                  onClick={handleSaveEvent}
                  disabled={isLoading}
                  style={{
                    flex: 1,
                    padding: "12px",
                    border: "none",
                    borderRadius: "8px",
                    background: isLoading ? "#9ca3af" : "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                    color: "#ffffff",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: isLoading ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  {isLoading ? (
                    <>
                      <i className="fa fa-spinner fa-spin" />
                      Saving...
                    </>
                  ) : (
                    "Save & Go To Event Page"
                  )}
                </button>
              </div>
            ) : (
              <button
                onClick={handleProceed}
                disabled={
                  (activeStep === 1 &&
                    (!eventName.trim() || !description.trim() || !eventType)) ||
                  (activeStep === 3 && (!eventUrlSlug.trim() || !/^[a-zA-Z0-9-]+$/i.test(eventUrlSlug.trim()))) ||
                  (activeStep === 5 && !timeZone) ||
                  isLoading
                }
                style={{
                  width: "100%",
                  padding: "14px",
                  border: "none",
                  borderRadius: "8px",
                  background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                  color: "#ffffff",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(24, 71, 120, 0.3)",
                  transition: "all 0.2s ease",
                  opacity:
                    (activeStep === 1 &&
                      (!eventName.trim() || !description.trim() || !eventType)) ||
                    (activeStep === 3 && (!eventUrlSlug.trim() || !/^[a-zA-Z0-9-]+$/i.test(eventUrlSlug.trim()))) ||
                    (activeStep === 5 && !timeZone)
                      ? 0.5
                      : 1,
                }}
                onMouseOver={(e) => {
                  if (e.currentTarget.style.opacity === "1") {
                    e.currentTarget.style.transform = "translateY(-2px)"
                    e.currentTarget.style.boxShadow = "0 6px 16px rgba(24, 71, 120, 0.4)"
                  }
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)"
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(24, 71, 120, 0.3)"
                }}
              >
                {activeStep === 5 ? "Create Event" : "Continue"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
